import { Box, Button, Flex, Spinner } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import Editor from 'react-simple-code-editor';

import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism.css'; //Example style, you can use another
import axios from 'axios';
import { OPEN_API_URL } from 'src/constants';
import { useBlockchainProvider } from 'src/providers/Blockchain/blockchainProvider';

export const CodeTab = ({ cartridge }: { cartridge: string }) => {
	const [code, setCode] = useState<string>(``);
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<boolean>(false);
	const [success, setSuccess] = useState<boolean>(false);
	const { jwt } = useBlockchainProvider();

	const [verified, setVerified] = useState<boolean>(false);

	const apiCallMock = (newCode: string) => {
		return axios
			.post(`${OPEN_API_URL}/v1/cartridge-code`, {
				jwt: jwt,
				cartridgeAddress: cartridge,
				newCode: newCode,
			})
			.then(() => {
				setVerified(false);
			});
	};

	useEffect(() => {
		axios
			.get(`${OPEN_API_URL}/v1/cartridge-code/${cartridge}?jwt=${jwt}`)
			.then((res: any) => {
				if (res.data != '') {
					setCode(res.data.code);
					setVerified(res.data.verified);
				}
			})
			.catch((e: any) => {
				console.log(e);
			});
	}, [cartridge, jwt]);

	const submitCode = () => {
		setLoading(true);
		setSuccess(false);
		setError(false);

		apiCallMock(code)
			.then(() => {
				setSuccess(true);
			})
			.catch(e => {
				console.log(e);
				setError(true);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return (
		<Flex
			flexDir="column"
			gap="10px"
		>
			<Flex
				align="center"
				justify={'space-between'}
			>
				<Box>Enter code that runs on Token Burn by user</Box>
				<Box color={verified ? 'green' : 'gray'}>{verified ? 'Verified' : 'Not Verified'}</Box>
			</Flex>
			<Flex
				flexDir="column"
				border="1px solid rgba(255,255,255,0.4)"
			>
				<Editor
					value={code}
					onValueChange={code => setCode(code)}
					highlight={code => highlight(code, languages.js)}
					padding={10}
					disabled={loading}
					style={{
						fontFamily: '"Fira code", "Fira Mono", monospace',
						fontSize: 12,
					}}
				/>
			</Flex>
			<Button
				disabled={loading || code.length == 0}
				onClick={submitCode}
			>
				{loading ? <Spinner /> : 'Submit code'}
			</Button>
			{error && (
				<Box
					fontSize="12px"
					color="red"
				>
					Error uploading code.
				</Box>
			)}
			{success && (
				<Box
					fontSize="12px"
					color="green"
				>
					Successfully uploaded code.
				</Box>
			)}
		</Flex>
	);
};
